import { c as _c } from "react/compiler-runtime";
import useCartReservationSpecialRequest from '@/contexts/cartContext/hooks/useCartReservationSpecialRequest';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { FFormIdEnum } from '@/types/form';
import { TextArea } from '@winelidays/wld-tsx-2/fields';
const SpecialRequestForm = () => {
    const $ = _c(12);
    const translate = useTranslate();
    const { specialRequest, setSpecialRequest } = useCartReservationSpecialRequest();
    let t0;
    if ($[0] !== translate) {
        t0 = translate("validation_page.special_request_form.title");
        $[0] = translate;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const label = t0;
    let t1;
    if ($[2] !== translate) {
        t1 = translate("validation_page.widget.special_request_form.placeholder");
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const placeHolder = t1;
    let t2;
    if ($[4] !== setSpecialRequest) {
        t2 = (e) => {
            setSpecialRequest(e.target.value);
        };
        $[4] = setSpecialRequest;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const handleChange = t2;
    let t3;
    if ($[6] !== handleChange || $[7] !== label || $[8] !== placeHolder || $[9] !== specialRequest || $[10] !== translate) {
        t3 = <TextArea translate={translate} value={specialRequest} placeholder={placeHolder} id="special-request" formId={FFormIdEnum.CART_VALIDATION} label={label} onChange={handleChange} className="mb-4"/>;
        $[6] = handleChange;
        $[7] = label;
        $[8] = placeHolder;
        $[9] = specialRequest;
        $[10] = translate;
        $[11] = t3;
    }
    else {
        t3 = $[11];
    }
    return t3;
};
export default SpecialRequestForm;
